import { Box, Grid, Tooltip, Typography } from "@mui/material";
import Home_Bg from "../assets/AIQ_Demo.mp4";
import knowledgexicon from "../assets/icons/upload.svg";
import schedulerxicon from "../assets/icons/set-up-svgrepo-com.svg";
import { useNavigate } from "react-router";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { updateInitialState } from "../redux/initialData";

const Home = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const video_BG_ref = useRef(null);
    const [userRole, setUserRole] = useState(localStorage.getItem("user_role"));

    useEffect(() => {
        let token = localStorage.getItem("token");
        if (token) {
            dispatch(updateInitialState({ key: "login_token", value: token }));
            setUserRole(localStorage.getItem("user_role"));
        }

        if (video_BG_ref.current) {
            let video = video_BG_ref.current;
            video.addEventListener("contextmenu", (event) => {
                event.preventDefault();
            });
            video.loop = true;
            video.autoplay = true;
            video.muted = true;
            video.playsInline = true;
            const videoPromise = video.play();
            if (videoPromise !== undefined) {
                videoPromise.catch((error) => {
                    console.error("Autoplay prevented:", error);
                });
            }
        }

        const handleUnload = () => {
            localStorage.removeItem("token");
            localStorage.removeItem("user_role");
            localStorage.removeItem("selected_tile");
        };

        window.addEventListener("beforeunload", handleUnload);
        window.addEventListener("unload", handleUnload);

        return () => {
            window.removeEventListener("beforeunload", handleUnload);
            window.removeEventListener("unload", handleUnload);
        };
    }, [dispatch, navigate]);

    const NavigateTiles = (tile) => {
        const token = localStorage.getItem("token");
        const role = localStorage.getItem("user_role");

        const accessMap = {
            "aiq-admin": ["schedulerx", "knowledgex"],
            "knowledgex-demo": ["knowledgex"],
            "schedulerx-demo": ["schedulerx"],
            "healthx-demo": ["schedulerx"],
            "test-healthx": ["schedulerx"],
            "aiq-demo": ["schedulerx"],
        };

        const routeMap = {
            schedulerx: "/scheduler_x",
            knowledgex: "/knowledge_x",
        };

        if (!token) {
            localStorage.setItem("selected_tile", tile);
            navigate("/login");
            return;
        }

        if (accessMap[role]?.includes(tile)) {
            navigate(routeMap[tile]);
        } else {
            alert("You do not have access to this section.");
        }
    };

    return (
        <Grid container sx={{ width: "100vw", height: "100vh", backgroundImage: `url(${Home_Bg})`, backgroundRepeat: "no-repeat", backgroundSize: "cover", position: "relative" }}>
            <Box ref={video_BG_ref} component={"video"} src={Home_Bg} sx={{ width: "100%", height: "100%", objectFit: "cover" }} />
            <Grid item xs={12} sx={{ textAlign: "right", position: "absolute", right: "5%", bottom: "10%" }}>
                <Box sx={{ fontSize: "58px", fontWeight: 600, background: "linear-gradient(to right, #7044ff, #ee3cff, #ff8029) text", WebkitTextFillColor: "transparent" }}>IntelligentX</Box>
                <Box sx={{ fontSize: "30px", fontWeight: 400, background: "linear-gradient(to right, #7044ff, #ee3cff, #ff8029) text", WebkitTextFillColor: "transparent" }}>Partner with the future of Intelligent Solutions. Explore our demos.</Box>
            </Grid>
            <Grid sx={{ position: "absolute", top: "10%", left: "5%", display: "flex", gap: "32px", color: "#FFF" }}>
                <Tile icon={schedulerxicon} title="SchedulerX" onClick={() => NavigateTiles("schedulerx")} />
                <Tile icon={knowledgexicon} title="KnowledgeX" onClick={() => NavigateTiles("knowledgex")} />
            </Grid>
        </Grid>
    );
};

const Tile = ({ icon, title, onClick }) => {
    return (
        <Grid sx={{ boxShadow: "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;", backgroundColor: "#FFF", width: "150px", height: "150px", display: "flex", flexDirection: "column", alignContent: "center", alignItems: "center", borderRadius: "10px" }}>
            <Tooltip title={<Typography sx={{ fontSize: "20px", fontWeight: 500 }}>{title}</Typography>}>
                <Box component={"img"} src={icon} onClick={onClick} sx={{ width: "100%", cursor: "pointer" }} />
            </Tooltip>
        </Grid>
    );
};

export default Home;
